import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";

/** Tenant panel navigasyon yapılandırması — saf config, UI yok */
export function getTenantNavSections(t) {
  return [
    {
      id: "overview",
      items: [
        {
          id: "dashboard",
          label: t("dashboard"),
          path: "/tenant/dashboard",
          Icon: DashboardOutlinedIcon,
        },
        {
          id: "subscription",
          label: t("planAndQuotas", { defaultValue: "Plan ve Kotalar" }),
          path: "/tenant/subscription",
          Icon: WorkspacePremiumOutlinedIcon,
        },
      ],
    },
    {
      id: "team",
      items: [
        {
          id: "doctors",
          label: t("doctors"),
          path: "/tenant/doctors",
          Icon: Groups2OutlinedIcon,
        },
        {
          id: "invite-admin-doctor",
          label: t("inviteAdminDoctor"),
          path: "/tenant/invite-admin-doctor",
          Icon: EmailOutlinedIcon,
        },
      ],
    },
    {
      id: "data",
      items: [
        {
          id: "patients",
          label: t("patients"),
          path: "/tenant/patients",
          Icon: GroupsOutlinedIcon,
        },
        {
          id: "permission-groups",
          label: t("permissionGroups"),
          path: "/tenant/permission-groups",
          Icon: SecurityOutlinedIcon,
        },
        {
          id: "collaboration-groups",
          label: t("collaborationGroups"),
          path: "/tenant/collaboration-groups",
          Icon: Groups2OutlinedIcon,
        },
      ],
    },
  ];
}

export function getTenantProfileItem(t) {
  return {
    id: "profile",
    label: t("profile"),
    path: "/tenant/profile",
    Icon: AccountCircleOutlinedIcon,
  };
}

export const TENANT_NAV_OPTIONS = {
  homePath: "/tenant/dashboard",
};
